import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, IconWrapper } from '@honda-canada/design-system-react';
import React from 'react';
import { variant1, variant2 } from '../constants';
import { useConfigurationByVariant } from '../VariantContext';
const configByVariant = {
    [variant1]: {
        iconName: 'tag',
        iconColor: 'red',
    },
    [variant2]: {
        iconName: 'specialOffer',
        iconColor: 'blue',
    },
};
/* Use zero width space for svg icon and text alignment, see
https://dimiterpetrov.com/blog/svg-icon-sizing-and-alignment/ */
const ZeroWidthSpace = '​​\u{200B}';
const SpecialOfferIcon = () => {
    const { iconName, iconColor } = useConfigurationByVariant(configByVariant);
    return (_jsxs(IconWrapper, { size: ['10px', '10px', '14px'], "data-testid": "cy-special-offer-icon", children: [ZeroWidthSpace, _jsx(Icon, { name: iconName, iconColor: iconColor })] }));
};
export default SpecialOfferIcon;
